import { useCallback } from 'react'
import * as React from 'react'
import styled from 'styled-components'
import { rem } from 'polished'
import removeSpace from 'lib/string/removeSpaceUtils'
import noop from 'lib/function/noop'
import clsx from 'clsx'
import TextButton from '../../../../LuxKit/Button/TextButton'

const ToggleItem = styled(TextButton)`
  &:not(.fit-buttons) {
    flex: 1;
    min-width: ${rem(130)};
  }
`

export interface ButtonToggleItem {
  id: string
  label: string
  [key: string]: any
}

interface Props {
  item: ButtonToggleItem
  active?: boolean
  onItemClick?: (item: ButtonToggleItem, e?: React.MouseEvent) => void
  fitButtons?: boolean
}

function ButtonGroupToggleItem(props: Props) {
  const { item, active, onItemClick = noop, fitButtons } = props

  const onToggleClick = useCallback((e: React.MouseEvent) => {
    onItemClick(item, e)
  }, [onItemClick, item])

  return <ToggleItem
    kind="secondary"
    key={item.id}
    isSelected={active}
    onClick={onToggleClick}
    data-testid={`ButtonGroupToggle-${removeSpace(item.label)}`}
    className={clsx({
      'fit-buttons': fitButtons,
    })}
  >
    {item.label}
  </ToggleItem>
}

export default ButtonGroupToggleItem
